module.exports = new __parcel__URL__("machines_community_hero_2023_level_1.233cbe63.png").toString();